import BaseHotspot from "./BaseHotspot";

/**
 * Type of hotspot where the action is to display a popup
 */
export default class GalleryHotspot extends BaseHotspot {
  /**
   * Initialises an gallery hotspot based on a config object.
   *
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'gallery',
   *   icon: {
   *     name: 'Icon name',
   *     uuid: '...',
   *     url?: 'https://...'
   *   },
   *   options: {
   *     title: 'Title',
   *     content?: [urls]
   *     gallery?: {
   *       name: 'Gallery',
   *       uuid: '...'
   *     }
   *   }
   * }
   */
  constructor(player, config) {
    super(player, config);

    this.loadIcon(config.icon, "gallery.png");

    this._config = config;
  }
}
